import React from 'react'
import { useThemeContext } from '../../../Context/ThemeContext';

function Billings() {
  const { mode } = useThemeContext();

  const containerBackground = mode === 'dark' ? '#2D2D2D' : '#ffffff';
  return (
    <div className='dashboard-container-overview'>
      vcvcb
    </div>
  )
}

export default Billings